import { render } from "./EditTag.vue?vue&type=template&id=642442ca&scoped=true"
import script from "./EditTag.vue?vue&type=script&lang=js"
export * from "./EditTag.vue?vue&type=script&lang=js"

import "./EditTag.vue?vue&type=style&index=0&id=642442ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642442ca"]])

export default __exports__